import React from 'react';
import { CASHFLOW_GROUPING } from '../treasury.constants';
import styles from './styles/periodToggle.module.scss';

const OPTIONS = [
    { key: CASHFLOW_GROUPING.QUARTERLY, label: 'Quarterly' },
    { key: CASHFLOW_GROUPING.MONTHLY, label: 'Monthly' },
];

/**
 * Two-pill segmented toggle shown in the header of the Cashflow Over
 * Time card. Pure presentational. Receives `value` + `onChange`.
 */
function PeriodToggle({ value, onChange }) {
    return (
        <div className={styles.toggle} role="tablist" aria-label="Cashflow grouping">
            {OPTIONS.map(({ key, label }) => {
                const active = key === value;
                return (
                    <button
                        key={key}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        className={[styles.option, active ? styles.active : null].filter(Boolean).join(' ')}
                        onClick={() => onChange?.(key)}>
                        {label}
                    </button>
                );
            })}
        </div>
    );
}

export default PeriodToggle;
